import { render, staticRenderFns } from "./TwoChannelPicker.vue?vue&type=template&id=0c878050&scoped=true&shadow"
import script from "./TwoChannelPicker.vue?vue&type=script&lang=js&shadow"
export * from "./TwoChannelPicker.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./TwoChannelPicker.vue?vue&type=style&index=0&id=0c878050&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c878050",
  null
  ,true
)

export default component.exports